import React,{useState,useEffect} from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import ModalHead from './ModalHead';
import Toast from './Toast';
import Ajax from './Ajax';
import {Inc} from "./Inc";
import {Styles} from './Styles';
import Loading from './Loading';

interface Props {
    uid:string,
    start(uid:string):void,
    close():void,
}

interface State {
    name:string,
    club:string,
    classroom:string,
}

let isLoading = true;

const Create = (props:Props)=> {
    Ajax.setUid(props.uid)
    const classes = Styles.base();
    const [toast,setToast] = useState("");
	const [states,setStates] = useState({
        name:"",
        club:"",
        classroom:"",
        phase:"edit",
    });
    const defErrors = {
        name:"",
        club:"",
        classroom:"",
    };
	const [errors,setErrors] = useState(defErrors);
	const closeToast = ()=>{
        setToast("");
	}    
	const change = (name: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
        let v = event.target.value.trim();
        setStates({ ...states, [name]: v });
    };
	const changeSelect = (name: keyof State) => (event: any) => {
        //console.log("select",event.target.value);
        setStates({ ...states, [name]: event.target.value });
    };
    const auto = ()=>{
        Ajax.send("play/auto",{},(res:any)=>{
            if( res.ok ){
                const n1 = Math.floor(Math.random()*Inc.clubs.length)
                const club = Inc.clubs[ n1 ];
                const n2 = Math.floor(Math.random()*Inc.classrooms.length)
                const classroom = Inc.classrooms[ n2 ];
                setStates({"name":res.name,"club":club,"classroom":classroom,"phase":"edit"});
            }
        })
    }
    const send = ()=>{
        Ajax.send("play/new",{name:states.name,club:states.club,classroom:states.classroom},(res:any)=>{
            //console.log("play/new",res,states);
            if( res.ok ){
                props.start(res.uid);
            }
        })
    }
    const edit = ()=>{
        setStates({...states,"phase":"edit"});
    }
    const validate = ()=>{
        let err = defErrors;
        let num = 0;
        if( states.name==="" ){
            err.name = "省略しちゃダメです";
            num++;
        } else if( states.name.length>8 ){
            err.name = "長すぎます";
            num++;
        }
        if( num>0 ){
            setErrors(err);
            setToast("困りました");
        } else {
            send();
        }
    }
    useEffect( ()=>{
        if( props.uid!=="" ){
            isLoading = false;           
            Ajax.send("play/last",{},(res:any)=>{
                //console.log(res);
                isLoading = false;
                if( res.ok ){
                    setStates({"name":res.name,"club":res.club,"classroom":res.classroom,"phase":"see"});
                } else {
                    setToast("キャラクターを作成しましょう");
                }
            });
        } else {
            setToast("キャラクターを作成しましょう");
        }
    },[props.uid]);

    if( props.uid==="" ){
        isLoading = false;
    }


    if( states.phase==="see" ){
        return (
            <div id="confirm" className={classes.modalRoot}>
                <ModalHead close={props.close}/>
                <Typography variant="subtitle1" className={classes.subtitle1}>現在のキャラクター</Typography>
                <Grid container spacing={1} style={{marginTop:"0.25em"}}>
                    <Grid item xs={12}>
                        <FormControl fullWidth={true}>
                            <FormLabel className={classes.formLabel}>名前</FormLabel>
                            <div className={classes.formValue}>{states.name}</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth={true}>
                            <FormLabel className={classes.formLabel}>部活</FormLabel>
                            <div className={classes.formValue}>{states.club}</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth={true}>
                            <FormLabel className={classes.formLabel}>クラス</FormLabel>
                            <div className={classes.formValue}>{states.classroom}</div>
                        </FormControl>
                    </Grid>
                </Grid>
                <div className={classes.modalBottom}>
                    <Button variant="outlined" color="primary" style={{width:"35%"}} onClick={edit}>変える</Button>
                    <Button variant="contained" color="primary" style={{width:"65%"}} onClick={send}>これで良い</Button>
                </div>
            </div>    
        )
    }

    return (
        <div id="confirm" className={classes.modalRoot}>
            <ModalHead close={props.close}/>
            <Typography variant="subtitle1" className={classes.subtitle1}>キャラクター作成</Typography>
            <Grid container spacing={1} style={{marginTop:"0.25em"}}>
                <Grid item xs={12}>
                    <FormControl fullWidth={true} error={errors.name!==""} style={{marginBottom:"1em"}}>
                        <FormLabel component="legend">名前（8文字以内）</FormLabel>
                        <TextField
                            id="name"
                            value={states.name}
                            onChange={change('name')}
                            margin="dense"
                            variant="outlined"
                            fullWidth
                        />
                        {errors.name!=="" &&
                        <FormHelperText>{errors.name}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth={true} error={states.club===""} style={{marginBottom:"1em"}}>
                        <FormLabel component="legend">部活</FormLabel>
                        <Select
                            native
                            value={states.club}
                            onChange={changeSelect("club")}
                            inputProps={{
                                name: "club",
                                id: "club-id",
                            }}
                            margin="none"
                            style={{marginTop:"0.3em"}}
                        >
                            <option key="key0" value=""></option>
                        {Inc.clubs.map( (name:string,index:number)=>{
                            const key = "club"+index;
                            return (
                                <option key={key} value={name}>{name}</option>
                            )
                        })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth={true} error={states.classroom===""} style={{marginBottom:"1em"}}>
                        <FormLabel component="legend">クラス</FormLabel>
                        <Select
                            native
                            value={states.classroom}
                            onChange={changeSelect("classroom")}
                            margin="none"
                            style={{marginTop:"0.3em"}}
                        >
                            <option key="key0" value=""></option>
                        {Inc.classrooms.map( (name:string,index:number)=>{
                            const key = "classroom"+index;
                            return (
                                <option key={key} value={name}>{name}</option>
                            )
                        })}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            <div className={classes.modalBottom}>
                <Button variant="outlined" color="primary" style={{width:"35%"}} onClick={auto}>自動生成</Button>
                <Button variant="contained" color="primary" style={{width:"65%"}} onClick={validate} disabled={states.name==="" || states.club==="" || states.classroom===""}>良い</Button>
            </div>
            <Loading isLoading={isLoading}/>
            <Toast close={closeToast} mes={toast}/>
        </div>
    );
}

export default Create;
